const LOG_LEVELS = {
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  DEBUG: 'DEBUG'
};

class Logger {
  static log(level, message, data = null) {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] ${level}: ${message}`;
    
    switch (level) {
      case LOG_LEVELS.ERROR:
        console.error(logMessage, data || '');
        break;
      case LOG_LEVELS.WARN:
        console.warn(logMessage, data || '');
        break;
      case LOG_LEVELS.DEBUG:
        if (process.env.NODE_ENV === 'development') {
          console.debug(logMessage, data || '');
        }
        break;
      default:
        console.log(logMessage, data || '');
    }
  }

  static info(message, data) {
    this.log(LOG_LEVELS.INFO, message, data);
  }

  static warn(message, data) {
    this.log(LOG_LEVELS.WARN, message, data);
  }

  static error(message, data) {
    this.log(LOG_LEVELS.ERROR, message, data);
  }

  static debug(message, data) {
    this.log(LOG_LEVELS.DEBUG, message, data);
  }
}

export default Logger; 